/**
 * Contact Form Handler
 */
document.addEventListener("DOMContentLoaded", () => {
    const rightBlock = document.getElementById("contacts-right-block");
    if (!rightBlock) return;
  
    const formView = rightBlock.querySelector(".js-form-view");
    const successView = rightBlock.querySelector(".js-success-view");
    const formElement = formView.querySelector('form');

    // Locale
    const isRu = document.documentElement.lang.toLowerCase().includes('ru');

    const sendingBtnText = isRu ? "Отправка..." : "Відправка...";

    let originalBtnText = isRu ? "Отправить" : "Надіслати";
    const initialBtn = formElement ? formElement.querySelector('button[type="submit"]') : null;
    if (initialBtn) {
        originalBtnText = initialBtn.innerText.trim();
    }

    const RESET_DELAY = 5000;
    
    // Submit handler
    if (formElement) {
        formElement.addEventListener('submit', () => {
            if (!formElement.checkValidity()) return;

            const btn = formElement.querySelector('button[type="submit"]');
            if (btn) {
                btn.disabled = true;
                btn.style.opacity = "0.7";
                btn.style.cursor = "wait";

                const span = btn.querySelector('span');
                if (span) {
                    span.innerText = sendingBtnText;
                } else {
                    btn.innerText = sendingBtnText;
                }
            }
        });
    }
  
    // Response handler
    document.addEventListener("reintegrationFormSubmitted", ({ detail }) => {
        const { form, data } = detail;
        if (!rightBlock.contains(form)) return;

        const btn = form.querySelector('button[type="submit"]');

        if (data.success) {
            form.reset();

            if (formView && successView) {
                formView.style.display = "none";
                successView.style.display = "flex";

                successView.style.opacity = "0";
                setTimeout(() => {
                    successView.style.opacity = "1";
                }, 50);

                setTimeout(() => {
                    successView.style.opacity = "0";

                    setTimeout(() => {
                        successView.style.display = "none";
                        formView.style.display = "block";
                        formView.style.opacity = "1";

                        restoreButton(btn);
                    }, 300);
                }, RESET_DELAY);
            }
        } else {
            console.error("Form submission failed: ", data);
            restoreButton(btn);

            const span = btn.querySelector('span');
            const errorText = isRu ? "Ошибка. Попробуйте еще раз" : "Помилка. Спробуйте ще раз";
            if (span) span.innerText = errorText;
        }
    });

    // Restore button state
    function restoreButton(btn) {
        if (!btn) return;

        btn.disabled = false;
        btn.style.opacity = "1";
        btn.style.cursor = "pointer";

        const span = btn.querySelector('span');
        if (span) {
            span.innerText = originalBtnText;
        } else {
            btn.innerText = originalBtnText;
        }
    }
});
